import { withEventBasedMarketTemplateModelSelectors } from '@swf/sports/models/market-templates/eventBased';

import { defaultState } from './defaultState';

export const selectors = withEventBasedMarketTemplateModelSelectors(defaultState, (slice) => ({
  hasPreloaded: () => slice((state) => state.hasPreloaded),
  isLoading: () => slice((state) => state.isLoading),
  hasErrored: () => slice((state) => state.error),
  errorCode: () => slice((state) => state.errorCode),
  marketsFeature: () => slice((state) => state.marketsFeature),
  event: () => slice((state) => Object.values(state.events)[0]),
  eventType: () => slice((state) => Object.values(state.eventTypes)[0]),
  hasInPlayMarkets: () => slice((state) => Object.values(state.markets).some((mkt) => mkt?.inPlay)),
  competition: () => slice((state) => Object.values(state.competitions)[0]),
  selectedSubMarketGroupType: () => slice((state) => state.selectedSubMarketGroupType)
}));
